export const GET_INVITES_FOR_PHARM__REQUEST = 'INVITES_TYPE__GET_INVITES_FOR_PHARM__REQUEST'
export const GET_INVITES_FOR_PHARM__SUCCESS = 'INVITES_TYPE__GET_INVITES_FOR_PHARM__SUCCESS'
export const GET_INVITES_FOR_PHARM__FAILURE = 'INVITES_TYPE__GET_INVITES_FOR_PHARM__FAILURE'
